module.exports = __webpack_public_path__ + "img/bingo_ball-79.3e86b6ae.png";